export default {
  title: "Perfil"
  , perfiles: { label: "Perfiles" }
  , telefono: { label: "Teléfono" }
  , interno: { label: "Interno" }
  , tiempoRestante: { label: "Tiempo restante" }
  , ultimoCambioContrasena: { label: "Último cambio de contraseña" }
  , proximoCambioContrasena: { label: "Próximo cambio de contraseña" }
  , errors: {
    BD2002: { text: "Ocurrió un error en el catálogo de Usuarios" }
    , WS2002: { text: "Ocurrió un error en el catálogo de Usuarios" }
    , JS2002: { text: "Ocurrió un error en el catálogo de Usuarios" }
    , CR2002: { text: "Ocurrió un error en el catálogo de Usuarios" }
    , PK2002: { text: "Ya existe un registro con el mismo usuario" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/seguridad/perfilUsuario.js